module.exports = __webpack_public_path__ + "static/img/5.c6cddf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/eng/5.png
// module id = 8e6t
// module chunks = 0